const UserClass = {
	// (null for regular users)

	// Users with free Premium access
	BETA: 'beta',

	// Users that can moderate the platform (Savee team members)
	MODERATOR: 'moderator',

	// Curators are users that have moderation rights and are part of the curated feed
	CURATOR: 'curator',

	// Inspo are users are special repository users that have a reduced profile info
	// Every time a curator saves something from an inspo user, that asset gets transfered to the curator and removed from the inspo.
	// We use this to help curator users to build their collections and therefore the curated feed.
	INSPO: 'inspo',
} as const;

export default UserClass;
